import { createSelector } from "reselect";
const stateProp = (s) => s;
const configuratorIdProp = (_, { id }) => id;
const frameSkuProp = (_, { frameSku }) => frameSku;
const lensTypeSkuProp = (_, { lensTypeSku }) => lensTypeSku;
const packageSkuProp = (_, { packageSku }) => packageSku;
const addOnSkuProp = (_, { addOnSku }) => addOnSku;
const getPrescriptionGlasses = (state) => state.prescriptionGlasses;
createSelector(
  getPrescriptionGlasses,
  (pg) => pg.prescription
);
export {
  addOnSkuProp,
  configuratorIdProp,
  frameSkuProp,
  getPrescriptionGlasses,
  lensTypeSkuProp,
  packageSkuProp,
  stateProp
};
//# sourceMappingURL=selectors.internal.js.map
